import React from "react";
import { Activity, Clock, Flag, Zap } from "lucide-react";
import { Effort } from "./types";

const EFFORT_ICON: Record<Effort, React.ElementType> = {
  micro: Zap,
  small: Clock,
  medium: Activity,
  large: Flag,
};
export const EffortIcon: React.FC<{ effort: Effort; size?: number }> = ({
  effort,
  size = 16,
}) => {
  const Icon = EFFORT_ICON[effort] || Clock;
  return <Icon size={size} aria-hidden="true" />;
};
